import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Raw axios client — talks straight to the network, never touches the outbox.
// The offline layer (sync.js) and api.js wrap this.
export const rawApi = axios.create({ baseURL: API, withCredentials: true });

rawApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("sp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// If the server revokes this session (signed in on another device beyond the
// 2-device cap), drop the token and bounce to sign-in with a one-time notice.
rawApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && err?.response?.data?.detail === "session_revoked") {
      localStorage.removeItem("sp_token");
      const p = window.location.pathname;
      if (p !== "/" && !p.startsWith("/auth") && !p.startsWith("/r/")) {
        localStorage.setItem("sp_kicked", "1");
        window.location.href = "/auth?mode=signin";
      }
    }
    return Promise.reject(err);
  }
);
